import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading } from "@cinch-labs/design-system";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import { SVG } from "@cinch-nx/shared-ui";
import Shield from "./assets/shield.svg";
import UnionShield from "./assets/union-shield.svg";
import styles from "./value-propositions.module.css";
var ValuePropositions = function(param) {
    var heading = param.heading, body = param.body, icon = param.icon;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles["root"],
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.imageContainer,
                children: icon === "shield" ? /*#__PURE__*/ _jsx(SVG, {
                    className: styles.icon,
                    children: Shield
                }) : /*#__PURE__*/ _jsx(SVG, {
                    className: styles.icon,
                    children: UnionShield
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        className: styles.heading,
                        children: heading
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.body,
                        children: renderWithResolver(body)
                    })
                ]
            })
        ]
    });
};
export default ValuePropositions;
